export const PropertyActions = {
  SET_PROPERTY_VALUE: '@@PROPERTY/SET_PROPERTY_VALUE',
};
